<template>
  <div class="p-message-preview-list__item p-message-preview-list__item--mobile is-active">
    <div class="p-message-preview-content">
      <div v-if="badgeUrl" style="display: flex; line-height: 20px; margin-bottom: 5px;">
        <div class="">
          <img :src="badgeUrl" style="margin-right: 10px; height: 20px; width: 20px;" />
        </div>
        <div class="p-message-preview-content__link" style="margin-bottom: 0;"><a :href="url" target="_blank">{{ url }}</a></div>
      </div>
      <div v-else class="p-message-preview-content__link"><a :href="url" target="_blank">{{ url }}</a></div>
      <div class="p-message-preview-content__title">{{ title }}</div>
      <div class="p-message-preview-content__text">{{ text }}</div>
    </div>
    <div class="p-message-preview__icon">
      <img :src="iconUrl" />
    </div>
    <div class="p-message-preview__image">
      <img :src="largeImageUrl" />
    </div>
    <div v-if="hasButtonA" class="p-message-preview__btns">
      <a
        v-if="actionButtonTextA"
        :href="actionButtonUrlA"
        target="_blank"
        class="c-btn c-btn--preview-mobile u-w49p u-h36"
      >
        <p class="c-btn__text">{{ actionButtonTextA }}</p>
      </a>
      <a
        v-if="actionButtonTextB"
        :href="actionButtonUrlB"
        target="_blank"
        class="c-btn c-btn--preview-mobile u-w49p u-h36"
      >
        <p class="c-btn__text">{{ actionButtonTextB }}</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    url: String,
    iconUrl: String,
    largeImageUrl: String,
    badgeUrl: String,
    hasButtonA: Boolean,
    hasButtonB: Boolean,
    actionButtonTextA: String,
    actionButtonUrlA: String,
    actionButtonTextB: String,
    actionButtonUrlB: String,

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.c-btn__text::selection {
    background: #209bb9;
}
</style>
